module.exports = __webpack_public_path__ + "assets/img/Group1.340274f5.png";